import { getApi } from './common/apis';

export default class VendorDataExportService {



    async directoryTree() {
        const response = await fetch(`${process.env.VUE_APP_ANSWER_BANK_SERVICE_URL}v2/question-set/list`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data
    }
    
    /**
     * Download vendor data for a specific question set
     * @param {number} questionSetId - The question set ID (0, 1, 2, 3, 4, etc.)
     * @param {string} format - 'excel' (default) or 'json'
     * @returns {Promise<Object>} - The API response with downloadUrl, fileName, and metadata
     */
    async downloadVendorData(questionSetId, format = 'excel') {
        try {
            const url = format === 'json'
                ? `v1/vendor-data-export?questionSetId=${questionSetId}&format=json`
                : `v1/vendor-data-export?questionSetId=${questionSetId}`;
            const response = await getApi(url, process.env.VUE_APP_COMMON_BASE_URL);
            return response;
        } catch (error) {
            console.error('Error downloading vendor data:', error);
            throw error;
        }
    }

    /**
     * Generic method to download any question set by ID
     * @param {number} questionSetId - The question set ID
     * @param {string} format - 'excel' (default) or 'json'
     * @returns {Promise<Object>} - The API response with downloadUrl, fileName, and metadata
     */
    async downloadByQuestionSetId(questionSetId, format = 'excel') {
        return await this.downloadVendorData(questionSetId, format);
    }
}
